export default __webpack_public_path__ + "static/media/_R.95d0dbdf.png";